import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { UpdateMyPasswordRequest } from '../../types/auth.js'

import { apiClient } from '../../lib/client.js'
import { meKeys } from './keys.js'

export interface UpdateMyPasswordResponse {
  message: string
}

export const useUpdateMyPasswordMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: UpdateMyPasswordRequest) => {
      const response = await apiClient.client.put<UpdateMyPasswordResponse>('/me/password', data)
      return response.data
    },
    onError: () => {
      void queryClient.invalidateQueries({ queryKey: meKeys.profile })
    },
  })
}
